import { render, staticRenderFns } from "./qualityControl.vue?vue&type=template&id=af4ddff0&scoped=true"
import script from "./qualityControl.vue?vue&type=script&lang=js"
export * from "./qualityControl.vue?vue&type=script&lang=js"
import style0 from "./qualityControl.vue?vue&type=style&index=0&id=af4ddff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ddff0",
  null
  
)

export default component.exports